<template>
  <div id="user-edit">
    <IForm ref="formInline" :model="edit" :elem="userElem" :rules="userRule"
           :label-width="80" @on-submit="toSubmit" :submit="false" :showMessage="true">

      <div slot="extend">
        <Row>
          <Col span="24"><FormItem label="用户名" prop="name" ><Input v-model="edit.name" type="text" placeholder="请输入用户名" maxlength="50" :disabled="edit.id?true:false"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="真实姓名" prop="realName" ><Input v-model="edit.realName" type="text" placeholder="请输入真实姓名" maxlength="50"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="角色" prop="roleId">
              <el-select v-model="edit.roleId" placeholder="请选择角色" clearable filterable style="width: 100%;">
                <el-option v-for="item in roles" :key="item.value" :value="item.value" :label="item.label" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="密码" prop="password" :required="!this.edit.id"><Input v-model="edit.password" type="text" placeholder="请输入密码" maxlength="50"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="联系方式" prop="phone" ><Input v-model="edit.phone" type="text" placeholder="请输入联系方式" maxlength="15"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="账号类型" prop="accountType" >
              <Select v-model="edit.accountType">
                <Option v-for="item in accountTypeList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="微信登录" prop="weixinLogin" >
              <Select v-model="edit.weixinLogin">
                <Option v-for="item in weixinLoginList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="备注"><Input v-model="edit.remark" type="text" placeholder="请输入备注" maxlength="50"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="状态" prop="status" >
              <Select v-model="edit.status">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </div>
    </IForm>

  </div>
</template>
<script>

import {_editUser, _getUserById,} from "@/services/manage/users";
export default {
  name: "UserEdit",
  props:{
    roles: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      edit: {
        name: "",
        realName: "",
        phone: "",
        roleId: "",
        accountType: 1,
        weixinLogin: 1,
        status: 1
      },
      init: "",
      accountTypeList:[
        {label: '正式账号', value: 1},
        {label: '临时账号', value: 2},
      ],
      weixinLoginList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      statusList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      userElem: [],
      userRule: {
        name: [
          {required: true, message: '用户名不能为空', trigger: 'blur'},
          {pattern: new RegExp('^([a-zA-Z]){1,15}@(\\d{1,11})$'),message: '账号名格式必须为 字母 + @ + 数字'},
          {minlength:15,maxlength:18,message:"账号长度必须为6-30位",trigger: 'blur'}
        ],
        realName: [
          {
            required: true,
            message: "真实姓名不能为空",
            trigger: "blur"
          }
        ],
        roleId: [
          {
            required: true,
            message: "请选择角色",
            trigger: "change",
            type:'number'
          }
        ],
        password: [
          {validator:function(rule, value, callback){
              if (!this.edit.id &&  (!value ||  value== '')) {
                callback(new Error('密码不能为空'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'blur' }
        ],
        accountType: [
          {
            required: true,
            message: "请选择账号类型",
            trigger: "change",
            type:'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择用户状态",
            trigger: "change",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.edit.accountType = 1;
      this.edit.status = 1;
    },
    handleEdit(row) {
      _getUserById({id: row.id}).then(res =>{
        const edit = Object.assign({}, row);
        this.edit = {...edit};
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _editUser(this.edit)
        .then(res => {
          if (res.errcode == 1) {
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}
</style>
